import React from 'react'
import { FiArrowDownLeft } from 'react-icons/fi'
import HistoryPage from '../dashboardShell/HistoryPage'

const usd = (value) => `$${Number(value || 0).toLocaleString()} USD`

// Deposit history (/deposit)
const Deposit = ({ route }) => (
  <HistoryPage
    route={route}
    topbarTitle="Deposit History"
    hero={{
      icon: <FiArrowDownLeft />,
      eyebrow: 'Deposits',
      title: 'Deposit history',
      description: 'Every deposit made to your account, with the balance after each one.',
    }}
    heroAside={(user) => (
      <div className="ud-hero-figure">
        <span>Total deposited</span>
        <strong>${Number(user.totaldeposit || 0).toLocaleString()}</strong>
      </div>
    )}
    sectionTitle="All deposits"
    getRows={(user) => user.deposit}
    columns={[
      { label: 'Transaction ID', render: (row) => row.id },
      { label: 'Type', render: (row) => <span className="ud-badge ud-badge-profit">{row.type || 'deposit'}</span> },
      { label: 'Amount', render: (row) => usd(row.amount) },
      { label: 'Date', render: (row) => row.date },
      { label: 'Balance', render: (row) => usd(row.balance) },
    ]}
    emptyText="You haven't made any deposits yet. Fund your account to start copy trading."
    emptyAction={{ to: '/fundwallet', label: 'Make a deposit' }}
  />
)

export default Deposit
